import React from "react";
import { TextVariant, TypographyNew } from "../typography/typography";
import { useTheme } from "styled-components";

type BaseNotificationBodyProps = {
  body?: string;
};

export default function BaseNotificationBody({
  body,
}: BaseNotificationBodyProps): JSX.Element | null {
  const theme = useTheme();
  return body ? (
    <TypographyNew
      variant={TextVariant.body1}
      color={theme.colors.grays2}
      marginTop={"10px"}
    >
      {body}
    </TypographyNew>
  ) : null;
}
